/** Privacy mask for dashboard amounts — shared across header + cards */
export function usePrivacyMask() {
  const revealAll = useState('privacy-reveal-all', () => false);
  const revealed = useState<Record<string, boolean>>('privacy-revealed', () => ({}));

  function isRevealed(key: string) {
    return !!revealAll.value || !!revealed.value[key];
  }

  function toggleSection(key: string) {
    // If global is on, first click turns global off and keeps only this section open
    if (revealAll.value) {
      revealAll.value = false;
      revealed.value = { [key]: true };
      return;
    }
    revealed.value = {
      ...revealed.value,
      [key]: !revealed.value[key],
    };
  }

  function toggleAll() {
    revealAll.value = !revealAll.value;
    if (revealAll.value) {
      // clear per-section so next close falls back to all masked
      revealed.value = {};
    }
  }

  function anyOpen() {
    return revealAll.value || Object.values(revealed.value).some(Boolean);
  }

  return { revealAll, revealed, isRevealed, toggleSection, toggleAll, anyOpen };
}
